export const setUpWbSlider = (slider: HTMLElement, sliderClasses: string[]) => {
  if (slider) {
    const slottedElements = slider.querySelectorAll('.webcomponent');

    slottedElements.forEach(element => {
      if (element.tagName !== 'SCRIPT') {
        element.classList.add(...sliderClasses);
        if (slider.parentElement) {
          slider.parentElement.appendChild(element);
        }
      }
    });
  }
};
